import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { AcademicRankResponse } from "../../models/dtos"; 

export const academicRanksApi = createApi({
  reducerPath: 'academicRanksApi',
  baseQuery: baseAuthQuery('AcademicRanks'),
  tagTypes: ['AcademicRank'],
  endpoints: (builder) => ({
    getAcademicRanks: builder.query<ApiResponse<AcademicRankResponse[]>, void>({
      query: () => "",
      providesTags: ['AcademicRank'],
    }),
    getAcademicRankById: builder.query<ApiResponse<AcademicRankResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['AcademicRank'],
    }),
    updateAcademicRank: builder.mutation<ApiResponse<AcademicRankResponse>, Partial<AcademicRankResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['AcademicRank'],
    }),
    deleteAcademicRank: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['AcademicRank'],
    }),
  }),
});
